import React from 'react'
import './styles.scss'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'

const AboutUsFourthComponent = () => {
    return (
        <Box className="AboutUsFourthComponentWrapper">
            <Box className="AboutUsFourthComponentContainer">
                <Typography variant='h2' className='AboutUsFourthComponentTitle'>
                    Take Action Today
                </Typography>
                <Typography variant='h3' className='AboutUsFourthComponentSubTitle'>
                    Elevate your digital security immediately.
                </Typography>

                <Link to='/signin' className='AboutUsFourthComponentLink'>
                    <Button className='AboutUsFourthComponentButton'>
                        Contact Us Now
                    </Button>
                </Link>
            </Box>
        </Box>

    )
}

export default AboutUsFourthComponent